export default __webpack_public_path__ + "e1ee2e8.png";